import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { DocumentReglementaire } from '@/models/DocumentReglementaire';
import dayjs from 'dayjs';

export interface RapportState {
    tableHeader: TableHeader[];
    page: number;
    nbOfPages: number;
    scroll: number;
    count: number,
    documentReglementaire: DocumentReglementaire[];
    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    isLoading: boolean;
    isZipLoading: boolean;
    filterSite: number[];
    filterGroupe: number[];
    filterSousGroupe: number[];
    filterEquipement: number[];
    filterDocumentDateFrom: string;
    filterDocumentDateTo: string;
    documentIdsToDownload: number[];
    error?: Error;
    nbRapports?: number;
}

export const initialState: RapportState = {
    documentReglementaire: [],
    tableHeader: [
        {
            label: '',
            sortData: 'uniqueDocumentId',
            sortStatus: SortType.NONE,
            width: '5%',
        },
        {
            label: 'rapports.intervention.data.intervention',
            sortData: 'interventionId',
            sortStatus: SortType.DESC,
            width: '10%',
        },
        {
            label: 'document.reglementaire.data.site',
            sortData: 'adresseSite',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'document.reglementaire.data.groupe',
            sortData: 'groupe',
            sortStatus: SortType.INACTIVE,
            width: '15%',
        },
        {
            label: 'document.reglementaire.data.sousgroupe',
            sortData: 'sousGroupeLibelle',
            sortStatus: SortType.INACTIVE,
            width: '15%',
        },
        {
            label: 'document.reglementaire.data.equipement',
            sortData: 'libelleEquipement',
            sortStatus: SortType.INACTIVE,
            width: '25%',
        },
        {
            label: 'document.reglementaire.data.date',
            sortData: 'dateDebutPrevue',
            sortStatus: SortType.INACTIVE,
            width: '10%',
        }
    ],
    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,

    sort: {
        sortData: 'interventionId',
        sortStatus: SortType.DESC,
    },

    filterSite: [],
    filterGroupe: [],
    filterSousGroupe: [],
    filterEquipement: [],
    documentIdsToDownload: [],
    filterDocumentDateFrom: dayjs().startOf('year').format('YYYY-MM-DD'),
    filterDocumentDateTo: dayjs().endOf('year').format('YYYY-MM-DD'),

    isLoading: false,
    isZipLoading: false,
};

export const state: RapportState = {
    ...initialState
};
